import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 20px 50px 30px;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1024px;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FieldItem = styled.div`
  flex: 1 1 240px;
  min-width: 220px;
  max-width: 320px;
`;

export const ItemsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ItemsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ItemCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.palette[300]};
  background: ${({theme}) => theme.palette[200]};
`;

export const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const ErrorMessage = styled.span`
  color: ${({theme}) => theme.errors[600]};
  font-size: 13px;
  line-height: 16px;
`;
